const BurgerIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='19.929'
      height='18'
      viewBox='0 0 19.929 18'
    >
      <g
        id='menu-button-of-three-horizontal-lines_1_'
        data-name='menu-button-of-three-horizontal-lines (1)'
        transform='translate(0 -6)'
      >
        <path
          id='Path_148332'
          data-name='Path 148332'
          d='M18,6H1.929a1.929,1.929,0,0,0,0,3.857H18A1.929,1.929,0,1,0,18,6Z'
          fill='#4c677b'
        />
        <path
          id='Path_148333'
          data-name='Path 148333'
          d='M18,50H1.929a1.929,1.929,0,1,0,0,3.857H18A1.929,1.929,0,1,0,18,50Z'
          transform='translate(0 -36.929)'
          fill='#4c677b'
        />
        <path
          id='Path_148334'
          data-name='Path 148334'
          d='M18,94H1.929a1.929,1.929,0,1,0,0,3.857H18A1.929,1.929,0,1,0,18,94Z'
          transform='translate(0 -73.857)'
          fill='#4c677b'
        />
      </g>
    </svg>
  );
};
export default BurgerIcon;
